import { db } from "../../data/base.js";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";

export const fetchCatalogues = async (uniqueCatalogues) => {
    try {
        const result = await Promise.all(
            uniqueCatalogues.map(async (catalogueId) => {
                const catalogueDocRef = doc(collection(db, "Catalogues"), catalogueId);
                const catalogueData = await getDoc(catalogueDocRef);
                if (catalogueData.exists()) {
                    return { id: catalogueData.id, ...catalogueData.data() };
                }
                return null;
            })
        );

        return result.filter((catalogue) => catalogue !== null);
    } catch (error) {
        console.error("Errore durante il recupero dei cataloghi:", error);
        throw error;
    }
};

export const fetchLines = async (lineIds) => {
    try {
        const result = await Promise.all(
            lineIds.map(async (lineId) => {
                const lineDocRef = doc(collection(db, "Linea"), lineId);
                const lineData = await getDoc(lineDocRef);
                if (lineData.exists()) {
                    return {
                        idLinea: lineId,
                        nome_linea: lineData.data().nome_linea,
                        listaRefsOcchiale: (lineData.data().listaRefsOcchiale || [])
                            .filter((ref) => ref && typeof ref.id === "string")
                            .map((ref) => ref.id)
                    };
                }
                return null;
            })
        );

        return result.filter((line) => line !== null);
    } catch (error) {
        console.error("Errore durante il recupero delle linee:", error);
        throw error;
    }
};

export const fetchProducts = async (productIds) => {
    try {
        const result = await Promise.all(
            productIds.map(async (productId) => {
                const productDocRef = doc(collection(db, "CataloguesProducts"), productId);
                const productData = await getDoc(productDocRef);
                if (productData.exists()) {
                    const data = productData.data();
                    return {
                        idProduct: productId,
                        nameModel: data.nameModel,
                        modelName: data.modelName,
                        name: data.name,
                        nome_modello: data.nome_modello,
                        glassesName: data.glassesName,
                        ...data
                    };
                }
                return null;
            })
        );

        return result.filter((glass) => glass !== null);
    } catch (error) {
        console.error("Errore durante il recupero degli occhiali:", error);
        throw error;
    }
};

export const fetchSizes = async (sizeIds) => {
    try {
        const result = await Promise.all(
            sizeIds.map(async (sizeId) => {
                const sizeDocRef = doc(collection(db, "Taglia"), sizeId);
                const sizeData = await getDoc(sizeDocRef);
                if (sizeData.exists()) {
                    return {
                        idTaglia: sizeId,
                        size: sizeData.data().size,
                        listaRefModels: (sizeData.data().listaRefModels || [])
                            .filter((ref) => ref && ref.id)
                            .map((ref) => ref.id)
                    };
                }
                return null;
            })
        );

        return result.filter((size) => size !== null);
    } catch (error) {
        console.error("Errore durante il recupero delle taglie:", error);
        throw error;
    }
};

export const fetchVariants = async (variantIds) => {
    try {
        const result = await Promise.all(
            variantIds.map(async (variantId) => {
                const variantDocRef = doc(collection(db, "CataloguesVariants"), variantId);
                const variantData = await getDoc(variantDocRef);
                if (variantData.exists()) {
                    const data = variantData.data();
                    return {
                        idVariant: variantId,
                        nameVariant: data.nameVariant,
                        name: data.name,
                        glassesName: data.glassesName,
                        esaColorFramePrimary: data.esaColorFramePrimary,
                        esaColorFrameSecondary: data.esaColorFrameSecondary,
                        esaColorLensesPrimary: data.esaColorLensesPrimary,
                        esaColorLensesSecondary: data.esaColorLensesSecondary,
                        ...data
                    };
                }
                return null;
            })
        );

        return result.filter((variant) => variant !== null);
    } catch (error) {
        console.error("Errore durante il recupero dei modelli:", error);
        throw error;
    }
};

export const fetchGatewaysFromCollection = async (catalogueIds = []) => {
    try {
        let gatewaysQuery = collection(db, "Gateways");
        let querySnapshot;

        if (catalogueIds && catalogueIds.length > 0) {
            // Se vengono forniti degli ID di catalogo, filtra i gateway che contengono almeno uno di questi cataloghi
            querySnapshot = await getDocs(gatewaysQuery);
            // Dobbiamo filtrare manualmente poiché Firestore non supporta direttamente query array-contains-any con più valori
            const gatewaysData = querySnapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(gateway =>
                    gateway.list_catalogues &&
                    gateway.list_catalogues.some(catalogueId =>
                        catalogueIds.includes(catalogueId)
                    )
                );
            return gatewaysData;
        } else {
            // Se non vengono forniti ID catalogo, restituisci tutti i gateway
            querySnapshot = await getDocs(gatewaysQuery);
            return querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
        }
    } catch (error) {
        console.error("Errore durante il recupero dei gateways:", error);
        throw error;
    }
};